import React, { useRef } from 'react';
import { useAppContext } from '../store/AppContext';
import { exportToJson, importFromJson } from '../utils/fileOps';
import SafeIcon from '../common/SafeIcon';
import { FiDownload, FiUpload, FiSettings, FiGlobe } from 'react-icons/fi';

const Settings = () => {
  const { data, updateSettings, setData, t } = useAppContext();
  const fileInputRef = useRef(null);

  const handleExport = () => {
    exportToJson(data);
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    if (file) {
      importFromJson(file, (importedData) => {
        setData(importedData);
        alert("Data imported successfully!");
      });
    }
  };

  return (
    <div className="space-y-8 max-w-3xl">
      <h1 className="text-2xl font-bold text-slate-800">{t('settings')}</h1>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="bg-slate-50 px-6 py-4 border-b border-slate-200 flex items-center gap-3">
          <SafeIcon icon={FiSettings} className="text-indigo-600" />
          <h2 className="text-lg font-semibold text-slate-800">{t('apiSettings')}</h2>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">{t('apiLogin')}</label>
            <input 
              type="text" 
              value={data.settings.apiLogin || ''}
              onChange={(e) => updateSettings({ apiLogin: e.target.value })}
              className="w-full border border-slate-300 rounded-lg px-4 py-2 bg-slate-50 focus:bg-white focus:ring-2 focus:ring-indigo-500"
              placeholder="DataForSEO Login"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">{t('apiPassword')}</label>
            <input 
              type="password" 
              value={data.settings.apiPassword || ''}
              onChange={(e) => updateSettings({ apiPassword: e.target.value })}
              className="w-full border border-slate-300 rounded-lg px-4 py-2 bg-slate-50 focus:bg-white focus:ring-2 focus:ring-indigo-500"
              placeholder="DataForSEO Password"
            />
          </div>
          <p className="text-xs text-slate-500">
            Note: If API credentials are not provided or if CORS prevents direct browser calls, the system will fall back to manual entry or simulated responses for testing.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="bg-slate-50 px-6 py-4 border-b border-slate-200 flex items-center gap-3">
          <SafeIcon icon={FiGlobe} className="text-teal-600" />
          <h2 className="text-lg font-semibold text-slate-800">Preferences</h2>
        </div>
        <div className="p-6">
          <label className="block text-sm font-medium text-slate-700 mb-1">{t('language')}</label>
          <select 
            value={data.settings.language || 'en'}
            onChange={(e) => updateSettings({ language: e.target.value })}
            className="w-full md:w-64 border border-slate-300 rounded-lg px-4 py-2 bg-white"
          >
            <option value="en">English</option>
            <option value="ro">Română</option>
          </select>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="bg-slate-50 px-6 py-4 border-b border-slate-200">
          <h2 className="text-lg font-semibold text-slate-800">{t('dataManagement')}</h2>
        </div>
        <div className="p-6 flex flex-wrap gap-4">
          <button 
            onClick={handleExport}
            className="flex items-center gap-2 bg-slate-800 text-white px-6 py-3 rounded-lg hover:bg-slate-900 transition-colors"
          >
            <SafeIcon icon={FiDownload} /> {t('exportData')}
          </button>
          
          <input 
            type="file" 
            accept=".json" 
            ref={fileInputRef} 
            onChange={handleImport} 
            className="hidden" 
          />
          <button 
            onClick={() => fileInputRef.current?.click()}
            className="flex items-center gap-2 bg-white border border-slate-300 text-slate-700 px-6 py-3 rounded-lg hover:bg-slate-50 transition-colors"
          >
            <SafeIcon icon={FiUpload} /> {t('importData')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;